<template>
  <div class="mt-0 pt-0">
    <v-card class="elevation-2" outlined>
      <v-card-title class="d-flex flex-wrap align-center" style="gap: 12px;">
        <div>
          <div class="text-h6">Terminos y condiciones</div>
          <div class="text-body-2 text--secondary">
            Administracion de terminos por unidad de negocio
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-chip color="deep-orange lighten-4" class="deep-orange--text text--darken-4" small>
          Total: {{ terminos.length }}
        </v-chip>
      </v-card-title>

      <v-card-text class="pt-2">
        <v-row dense class="mb-2">
          <v-col cols="12" md="5">
            <v-text-field
              v-model="search"
              dense
              outlined
              clearable
              prepend-inner-icon="mdi-magnify"
              label="Buscar terminos"
              hide-details
            />
          </v-col>
          <v-col cols="12" md="7" class="d-flex justify-end align-center" style="gap: 8px;">
            <v-btn color="deep-orange" text @click="listar">
              <v-icon left>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
            <v-btn color="deep-orange" dark depressed @click="abrirNuevo">
              <v-icon left>mdi-plus</v-icon>
              Agregar terminos
            </v-btn>
          </v-col>
        </v-row>

        <v-data-table
          :headers="headers"
          :items="terminosFiltrados"
          :loading="loading"
          :items-per-page="15"
          dense
          class="elevation-1"
          loading-text="Cargando terminos..."
          no-data-text="No hay terminos para mostrar"
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table" />
          </template>

          <template v-slot:[`item.descripcion`]="{ item }">
            <span class="text-truncate d-inline-block" style="max-width: 280px;">
              {{ item.descripcion || '-' }}
            </span>
          </template>

          <template v-slot:[`item.contenido`]="{ item }">
            <span class="text-truncate d-inline-block" style="max-width: 320px;">
              {{ resumenContenido(item.contenido) }}
            </span>
          </template>

          <template v-slot:[`item.fecha_registro`]="{ item }">
            {{ formatFecha(item.fecha_registro) }}
          </template>

          <template v-slot:[`item.opt`]="{ item }">
            <v-btn icon small color="deep-orange" @click="abrirEditar(item)" title="Editar">
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
          </template>
        </v-data-table>

        <p v-if="msg" class="text-center red--text ma-2" style="font-size:0.85rem;">
          <b>{{ msg }}</b>
        </p>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialog" max-width="900" persistent scrollable>
      <v-card>
        <v-card-title class="deep-orange white--text py-3">
          <v-icon color="white" left>{{ form.id ? 'mdi-pencil' : 'mdi-plus' }}</v-icon>
          {{ form.id ? 'Editar terminos' : 'Agregar terminos' }}
        </v-card-title>

        <v-card-text class="pt-4">
          <v-form ref="formTerminos" v-model="formValido">
            <v-row dense>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="form.version_code"
                  label="Version"
                  outlined
                  dense
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col cols="12" md="8">
                <v-text-field
                  v-model="form.title"
                  label="Titulo"
                  outlined
                  dense
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="form.descripcion"
                  label="Descripcion"
                  outlined
                  dense
                  rows="2"
                  auto-grow
                />
              </v-col>
              <v-col cols="12">
                <div class="d-flex flex-wrap align-center mb-2" style="gap: 8px;">
                  <div class="text-body-2 font-weight-medium">Contenido</div>
                  <v-spacer></v-spacer>
                  <v-btn-toggle v-model="modoContenido" dense mandatory>
                    <v-btn small value="visual">
                      <v-icon left small>mdi-eye-outline</v-icon>
                      Visual
                    </v-btn>
                    <v-btn small value="html">
                      <v-icon left small>mdi-code-tags</v-icon>
                      HTML
                    </v-btn>
                  </v-btn-toggle>
                </div>
                <div v-if="modoContenido === 'visual'" class="tc-rich-editor">
                  <vue-editor v-model="form.contenido" :editor-toolbar="editorToolbar" />
                </div>
                <v-textarea
                  v-else
                  v-model="form.contenido"
                  label="Contenido HTML"
                  outlined
                  rows="16"
                  auto-grow
                  spellcheck="false"
                  class="tc-html-editor"
                />
                <div v-if="contenidoError" class="red--text text-caption mt-1">
                  {{ contenidoError }}
                </div>
              </v-col>
            </v-row>
          </v-form>
          <v-alert v-if="msgForm" dense outlined type="error" class="mb-0">
            {{ msgForm }}
          </v-alert>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-1" :disabled="saving" @click="cerrarDialog">
            Cancelar
          </v-btn>
          <v-btn color="deep-orange" dark depressed :loading="saving" @click="guardar">
            <v-icon left small>mdi-content-save</v-icon>
            Guardar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { VueEditor } from 'vue2-editor';
import { createTerminosCondiciones, terminos_condiciones, updateTerminosCondiciones } from './utils';
  export default {
  components: { VueEditor },
    data() {
        return{
            loading: false,
            saving: false,
            dialog: false,
            formValido: false,
            msg: '',
            msgForm: '',
            contenidoError: '',
            search: '',
            terminos: [],
            modoContenido: 'visual',
            editorToolbar: [
              ['bold', 'italic', 'underline', 'strike'],
              [{ header: [1, 2, 3, 4, 5, 6, false] }],
              [{ list: 'ordered' }, { list: 'bullet' }],
              [{ align: [] }],
              [{ color: [] }, { background: [] }],
              ['blockquote', 'code-block'],
              ['link'],
              ['clean'],
            ],
            headers: [
              { text: 'Version', value: 'version_code', width: 120 },
              { text: 'Titulo', value: 'title' },
              { text: 'Descripcion', value: 'descripcion' },
              { text: 'Contenido', value: 'contenido' },
              { text: 'Fecha registro', value: 'fecha_registro', width: 160 },
              { text: '', value: 'opt', sortable: false, align: 'end', width: 80 },
            ],
            form: {
                id: null,
                version_code: '',
                title: '',
                contenido: '',
                descripcion: '',
                unidad_negocio: null,
            },
            rules: {
              required: value => !!String(value || '').trim() || 'Campo requerido',
            },
        }
    },
    computed: {
        unidadNegocioId() {
            return this.$store.state.CARGO && this.$store.state.CARGO.sede
                ? this.$store.state.CARGO.sede.unidad_negocio
                : null;
        },
        terminosFiltrados() {
            if(!this.search) return this.terminos;
            const q = this.search.toLowerCase();
            return this.terminos.filter(item =>
                Object.values(item).some(value => String(value || '').toLowerCase().includes(q))
            );
        },
    },
    watch:{
        '$store.state.CARGO': function(){
            this.listar()
        }
    },
    methods: {
        formVacio(){
            return {
                id: null,
                version_code: '',
                title: '',
                contenido: '',
                descripcion: '',
                unidad_negocio: null,
            };
        },
        async listar(){
            if(!this.unidadNegocioId) return;
            this.loading = true
            this.msg = ''
            const q = {
                unidad_negocio: this.unidadNegocioId
            }
            try {
                const r = await terminos_condiciones(q)
                this.terminos = Array.isArray(r) ? r : []
            } catch (e) {
                window.console.error(e)
                this.msg = 'No se pudo cargar la lista de terminos'
            } finally {
                this.loading = false
            }
        },
        abrirNuevo(){
            this.msgForm = ''
            this.contenidoError = ''
            this.modoContenido = 'visual'
            this.form = this.formVacio()
            this.form.unidad_negocio = this.unidadNegocioId
            this.dialog = true
            this.$nextTick(() => {
                if(this.$refs.formTerminos) this.$refs.formTerminos.resetValidation()
            })
        },
        abrirEditar(item){
            this.msgForm = ''
            this.contenidoError = ''
            this.modoContenido = 'visual'
            this.form = {
                id: item.id,
                version_code: item.version_code || '',
                title: item.title || '',
                contenido: item.contenido || '',
                descripcion: item.descripcion || '',
                unidad_negocio: item.unidad_negocio || this.unidadNegocioId,
            }
            this.dialog = true
            this.$nextTick(() => {
                if(this.$refs.formTerminos) this.$refs.formTerminos.resetValidation()
            })
        },
        cerrarDialog(){
            if(this.saving) return
            this.dialog = false
            this.msgForm = ''
            this.contenidoError = ''
        },
        async guardar(){
            this.msgForm = ''
            this.contenidoError = ''
            const valido = this.$refs.formTerminos ? this.$refs.formTerminos.validate() : true
            if(!valido) return
            if(!this.tieneContenido(this.form.contenido)) {
                this.contenidoError = 'Campo requerido'
                return
            }
            if(!this.unidadNegocioId) {
                this.msgForm = 'No se encontro la unidad de negocio'
                return
            }
            const input = {
                version_code: this.form.version_code,
                title: this.form.title,
                contenido: this.form.contenido,
                descripcion: this.form.descripcion,
                unidad_negocio: this.unidadNegocioId,
            }
            if(this.form.id) input.id = this.form.id
            this.saving = true
            try {
                const res = this.form.id
                    ? await updateTerminosCondiciones(input)
                    : await createTerminosCondiciones(input)
                if(res && res.error) {
                    this.msgForm = res.error
                    return
                }
                this.dialog = false
                await this.listar()
            } catch (e) {
                window.console.error(e)
                this.msgForm = 'No se pudo guardar los terminos'
            } finally {
                this.saving = false
            }
        },
        resumenContenido(value){
            if(!value) return '-'
            return String(value).replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim()
        },
        tieneContenido(value){
            return this.resumenContenido(value).replace(/&nbsp;/g, '').trim().length > 0
        },
        formatFecha(value){
            if(!value) return '-'
            const fecha = new Date(value)
            if(Number.isNaN(fecha.getTime())) return value
            return fecha.toLocaleDateString('es-BO')
        }
    },
    mounted() { 
        this.listar()
    },
  };
</script>

<style scoped>
.tc-rich-editor ::v-deep .ql-toolbar {
  border-radius: 4px 4px 0 0;
}

.tc-rich-editor ::v-deep .ql-container {
  min-height: 360px;
  border-radius: 0 0 4px 4px;
}

.tc-rich-editor ::v-deep .ql-editor {
  min-height: 360px;
  font-size: 14px;
  line-height: 1.5;
}

.tc-rich-editor >>> .ql-editor {
  min-height: 360px;
}
</style>
